import { Component, EventEmitter, Output } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'ngx-botones-parcela',
  template: `
    <button
      nbButton
      ghost
      status="basic"
      title="Editar"
      (click)="editar()">

      <nb-icon icon="edit-outline"></nb-icon>

    </button>

    <button
      nbButton
      ghost
      status="danger"
      title="Eliminar"
      (click)="eliminar()">

      <nb-icon icon="trash-2-outline"></nb-icon>

    </button>
  `
})
export class BotonesParcelaComponent implements ViewCell {

  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

  value: any;
  rowData: any;

  editar(): void {
    this.edit.emit(this.rowData);
  }

  eliminar(): void {
    this.delete.emit(this.rowData);
  }
}